import React, { useState } from "react";
// import { Modal, Button } from 'antd';
import {
  Button,
  Form,
  Modal,
  ModalBody,
  Row,
  Tabs,
  Tab,
} from "react-bootstrap";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { logout } from "../Helpers/API/AuthApi";
import { toast } from "react-toastify";
import { refreshPage } from "../Helpers/Utilities/Common";

const LogoutModal = ({ visible, onCancel }) => {
  const navigateto = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    const res = await logout();

    if (res.data) {
      toast.success(res.data.message, {
        autoClose: 500,
      });
      localStorage.clear();
      setTimeout(() => {
        navigateto("/");
        // refreshPage()
      }, 1000);
    } else if (res.error) {
      setIsLoading(false);
      res.error.data.messages.error_messages.map((errMsg) =>
        toast.error(errMsg)
      );
      localStorage.clear();
      toast.loading("Logging you out...", {
        autoClose: 2000,
        closeButton: true,
      });
      setTimeout(() => {
        navigateto("/");
        // refreshPage()
      }, 1000);
    }
  };

  return (
    <Modal
      show={visible}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      size="md"
      centered
    >
      <Modal.Body>
        <div className="row">
          <div className="col-12 align-wb-center">
            {/* <img src={trash} width={50} height={50} /> */}
          </div>
          <div className="col-12 align-wb-center">
            Are you sure you want to log out?
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-sm-6">
            <Button
              size="sm"
              className="action-btn cancel"
              style={{ width: "100%" }}
              onClick={onCancel}
            >
              Cancel
            </Button>
          </div>
          <div className="col-sm-6">
            <Button
              size="sm"
              className={`action-btn save ${isLoading ? "loader" : ""}`}
              style={{ width: "100%", position: "relative" }}
              // onClick={() => navigateto("/")}
              onClick={handleLogout}
              disabled={isLoading}
            >
              {isLoading && (
                <span style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Spin size="small" />
                </span>
              )}
              <span style={{ visibility: isLoading ? "hidden" : "visible" }}>
                Confirm
              </span>
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LogoutModal;
